import React, { Fragment } from 'react';
import axios from 'axios'
import Qs from 'qs';
import { Link } from 'react-router-dom';
import Gallery from "react-photo-gallery";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

import PerfectScrollbar from 'react-perfect-scrollbar';

import {
    Row,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    ListGroup,
    CardHeader,
    Card,
    Button,
    Progress,
    Input
} from 'reactstrap';

import Swal from 'sweetalert2'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getRealImageSrc, clearSession } from 'session';

export default class GalleryShow extends React.Component {

    constructor(props) {
        super(props);
        this.state = { items: [], is_admin: 0, current_lightbox_images: [], currentPostImageIndex: 0, viewerIsOpen: false, searchValue:"" }
    }

    componentDidMount() {
        document.getElementById("gallery_modal_loader").style.display = "block";
        let session = window.localStorage;
        axios.post(session.ch_action_url + "/action/get_project_gallery", Qs.stringify({
            token: "",
        })).then(res => {
            document.getElementById("gallery_modal_loader").style.display = "none";
            if (res.data.status === -1) {
                clearSession();
            }
            else if (res.data.status === 0) {
                Swal.fire(
                    'Operation Failed!',
                    res.data.info,
                    'error');
                this.setState({ isLoading: false });
            }
            else {
                let items = res.data.data;
                this.setState({ items: items });
            }
        });
    }

    handleSearchAction(e, action_name) {
        if (action_name === "keydown") {
            if (e.key === "Enter" && e.target.value !== "") {
                this.setState({ searchValue: e.target.value });
            }
        }
        else if (action_name === "onchange") {
            this.setState({ searchValue: e.target.value });
        }
    }

    handleSearchFilter(item) {
        if (this.state.searchValue === "" || (this.state.searchValue !== "" && (item.name.indexOf(this.state.searchValue) >= 0))) {
            return true;
        }

        

        return false;
    }


    handleViewSingleEvent(e, id) {
        if (e !== null) {
            e.preventDefault();
        }
        this.props.handleViewSingleEvent(id);
    }


    openLightbox(post_id, index) {

        let posts = this.state.items;
        let post = null;
        for (let i = 0; i < posts.length; i++) {
            if (posts[i].id === post_id) {
                post = posts[i];
                break;
            }
        }
        let images = [];
        for (let i = 0; i < post.images.length; i++) {
            images.push(getRealImageSrc(post.images[i].url))
        }
        this.setState({ current_lightbox_images: images, currentPostImageIndex: index, viewerIsOpen: true });
    }

    closeLightbox() {
        this.setState({ current_lightbox_images: [], currentPostImageIndex: 0, viewerIsOpen: false });
    };


    renderSelectImages({
        index,
        left,
        top,
        photo }, post_id, image_size) {

        let margin = "2px";
        let imgStyle = {
            transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s",
            width: "100%",
            height: "100%"
        };
        let selectedImgStyle = {
            transform: "translateZ(0px) scale3d(0.9, 0.9, 1)",
            transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s",
            width: "100%",
            height: "100%"
        };
        let cont = {
            backgroundColor: "#eee",
            cursor: "pointer",
            overflow: "hidden",
            position: "relative"
        };

        //calculate x,y scale
        let sx = (100 - (30 / photo.width) * 100) / 100;
        let sy = (100 - (30 / photo.height) * 100) / 100;
        selectedImgStyle.transform = `translateZ(0px) scale3d(${sx}, ${sy}, 1)`;

        // if (direction === "column") {
        //   cont.position = "absolute";
        //   cont.left = left;
        //   cont.top = top;
        // }
        let maxWidth = 500;
        let maxHeight = 350;
        if (photo.height > photo.width) {
            maxWidth = maxHeight * (photo.width / photo.height);
        }
        else {
            maxHeight = maxWidth * (photo.height / photo.width);
        }
        //maxHeight:maxHeight+"px", maxWidth:maxWidth+"px",
        return (
            <div
                style={image_size > 1 ? { margin, height: photo.height, width: photo.width, ...cont } : { margin, maxHeight: maxHeight + "px", maxWidth: maxWidth + "px", height: photo.height, width: photo.width, ...cont }}
                className={"not-selected"}>
                <img
                    alt={photo.title}
                    style={{ ...imgStyle }}
                    {...{ "src": getRealImageSrc(photo.url) }}
                    onClick={() => this.openLightbox(post_id, index)}
                />
                <style>{`.not-selected:hover{outline:2px solid #06befa}`}</style>
            </div>
        );

    }


    getImageInstance(images) {
        let instances = [];
        for (let i = 0; i < images.length; i++) {
            let temp = { src: images[i].url, width: 4, height: 3 };
            instances.push(temp);
        }
    }

    render() {
        return (
            <Fragment>
                <PerfectScrollbar options={{ suppressScrollX: true, wheelPropagation: true }}>
                    <div className="pt-2 pb-3" id="show_main_content_div_post" style={{ height: "calc(100vh - 90px)" }}>
                        <div className="pb-3 pt-2" style={{ maxWidth: "1000px", margin: "auto" }}>
                            <div className="d-flex justify-content-between p-2 align-items-center" style={{ borderBottom: "1px gray solid" }}>
                                <div className="d-flex">
                                    <div className="ml-2 search-wrapper is-active">
                                        <span className="icon-wrapper text-black">
                                            <FontAwesomeIcon icon={['fas', 'search']} />
                                        </span>
                                        <Input id="file_body_search" key="file_body_search" style={{ borderColor: "#b2b3cc" }} onKeyPress={(e) => this.handleSearchAction(e, "keydown")} onChange={(e) => this.handleSearchAction(e, "onchange")} className="rounded-pill" placeholder={"searching..."} type="search" />
                                    </div>
                                </div>
                            </div>
                            <div className="align-items-center justify-content-center loader_100" id="gallery_modal_loader" style={{ width: "100%", display: "none" }}>
                                <Progress value="100" striped animated className="progress-bar progress-animated-alt" color="warning" >Loading Data, please wait...</Progress>
                            </div>
                            <div className="p-2">
                                {this.state.items.length > 0 && this.state.items.map(post => (
                                    this.handleSearchFilter(post) &&
                                    <Card className="pb-2 mb-4 mt-2" key={"gallery_card_" + post.id} style={{ maxWidth: "1000px", margin: "auto" }} id={post.id}>
                                        <CardHeader className="border-0">
                                    
                                            <div className="d-flex justify-content-between mb-1">
                                                <div style={{ paddingLeft: "0px" }}>
                                                    <div className="pl-0">
                                                        <a className="font-weight-bold font-size-lg text-black" href="" onClick={(e) => e.preventDefault()}>
                                                            {post.name}
                                                        </a>

                                                    </div>
                                                    <div className="d-flex">
                                                        <small className="text-black-50 pt-1 d-block ml-2">
                                                            on: <b className="text-first">{post.datetime}</b>
                                                        </small>
                                                    </div>
                                                </div>
                                                <div className="card-header--actions card-tr-actions d-flex">
                                                    
                                                </div>
                                            </div>

                                        </CardHeader>
                                        <div className="card-body pt-0" >
                                            {post.images !== undefined && post.images.length > 0 && <Gallery photos={post.images} renderImage={({ index, left, top, photo }) => this.renderSelectImages({ index, left, top, photo }, post.id, post.images.length)} />}
                                        </div>
                                    </Card>
                                ))}

                            </div>
                        </div>
                    </div>
                </PerfectScrollbar>
                {this.state.viewerIsOpen && (
                    <Lightbox
                        mainSrc={this.state.current_lightbox_images[this.state.currentPostImageIndex]}
                        nextSrc={this.state.current_lightbox_images[(this.state.currentPostImageIndex + 1) % this.state.current_lightbox_images.length]}
                        prevSrc={this.state.current_lightbox_images[(this.state.currentPostImageIndex + this.state.current_lightbox_images.length - 1) % this.state.current_lightbox_images.length]}
                        onCloseRequest={() => this.setState({ viewerIsOpen: false })}
                        onMovePrevRequest={() =>
                            this.setState({
                                currentPostImageIndex: (this.state.currentPostImageIndex + this.state.current_lightbox_images.length - 1) % this.state.current_lightbox_images.length,
                            })
                        }
                        onMoveNextRequest={() =>
                            this.setState({
                                currentPostImageIndex: (this.state.currentPostImageIndex + 1) % this.state.current_lightbox_images.length,
                            })
                        }
                    />
                )}
            </Fragment>
        );
    }
}